import React from "react";
import ScreenOneComp from "../components/ScreenOneComp";
import { withRouter } from "react-router-dom";
import closeIcon from "../images/Icon (2).svg";
import ScreenTwoCompNew from "./ScreenTwoCompNew";

const PaymentComp = (props) => {
   const { step, setStep, history } = props;

   const navigateFun = () => {
      history.push("/notes");
   };
   const startSubscriptionFun = () => {
      setStep(2);
   };
   // Handles close icon functionality
   const closeIconFun = () => {
      // if (step > 1) {
      //    setStep(step - 1);
      // }
      history.push("/notes");
   };

   return (
      <div className="pg-center-aline-container-new-ui d-relative">
         <div className="trial-new-flow-background-payment-link" />
         {step !== 1 && (
            <div className="pg-close-icon-container-new-ui">
               <img className="" src={closeIcon} alt="close" onClick={closeIconFun} />
            </div>
         )}
         {step === 1 && <ScreenOneComp startSubscriptionFun={startSubscriptionFun} onClick={navigateFun} {...props} />}
         {step === 2 && <ScreenTwoCompNew {...props} step={step} />}
      </div>
   );
};

export default withRouter(PaymentComp);
